const sectionTextWithButtonCss = `
[data-type='section-text-with-button'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-text-with-button'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-text-with-button'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h1,
[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h2,
[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  line-height: normal;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card .title-card {
  margin-bottom: 22px;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card .btn-card {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  text-decoration: none;
  border: solid 1px var(--btn-background-color, #214a88);
  background-color: var(--btn-background-color, #214a88);
  color: var(--btn-text-color, #ffffff);
  padding: 10px 50px;
  border-radius: 20px;
  font-size: 14px;
  line-height: normal;
  transition: all 0.3s;
}

[data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card .btn-card:hover {
  background-color: #ffffff !important;
  color: var(--btn-background-color, #214a88) !important;
}

@container (max-width: 768px) {
  [data-type='section-text-with-button'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-text-with-button'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-text-with-button'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h1,
  [data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h2,
  [data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card h3 {
    font-size: 20px;
  }

  [data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card p {
    font-size: 14px;
  }

  [data-type='section-text-with-button'] [data-attribute='card-container'] .wrap-card .btn-card {
    font-size: 14px;
  }
}
`;
export default sectionTextWithButtonCss;
